export default __webpack_public_path__ + "static/media/accomm_img_6.4b9bbda9.JPG";